import React from 'react';
import ProcessTabContainer from './ProcessTabContainer';

function ProcessPage() {
    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between">
                <h1>
                    <i className="bi bi-list-task"></i> Process Queues
                </h1>
            </div>
            <ProcessTabContainer />
        </div>
    );
}

export default ProcessPage;
